import type { FC } from "react";

import type { PageLink } from "~/root";
import { useUiKitComponents } from "~/shared/ui-kit";
import { AccordionItem } from "~/shared/ui-kit/accordion/AccordionItem";

import type { MenuItemType } from "../HeaderV2";

type NavbarItemMobileProps = MenuItemType & {
  onRouteClick: () => void;
  clickHeaderSub: (targetUrl: string) => void;
  clickHeaderMain: (targetUrl: string) => void;
  lang: LanguageCode;
  buildLink: (page: PageLink) => string;
};

export const NavbarItemMobile: FC<NavbarItemMobileProps> = ({
  id,
  variant,
  link,
  translations,
  items,
  onRouteClick,
  clickHeaderSub,
  clickHeaderMain,
  buildLink,
}) => {
  const { Link } = useUiKitComponents();

  const translation = translations?.[0];
  const pageLink = buildLink(link);

  return (
    <div className="navbar-accordion-mobile">
      {variant === "default" && (
        <AccordionItem key={id} variant={"secondary"} title={translation?.name}>
          {items?.map((item) => (
            <Link
              href={buildLink(item?.menu_item_subItem_id?.link)}
              key={item?.menu_item_subItem_id?.id}
              onClick={() => {
                onRouteClick();
                clickHeaderSub(pageLink);
              }}
            >
              {item?.menu_item_subItem_id?.translations?.[0]?.name}
            </Link>
          ))}
        </AccordionItem>
      )}

      {variant === "underline" && (
        <div className="navbar-item-jackpass-wrapper">
          <div className="navbar-item-jackpass">
            <Link
              href={pageLink}
              onClick={() => {
                onRouteClick();
                clickHeaderMain(pageLink);
              }}
              className="navbar-item-content-jackpass"
            >
              {translation?.name}
            </Link>
          </div>
        </div>
      )}

      {variant === "emphasized" && (
        <div className="navbar-item-vip navbar-item-mobile-wrapper">
          <div className="navbar-item-vip-icon" />
          <Link
            href={pageLink || "/"}
            className="navbar-item-content-vip"
            onClick={() => {
              onRouteClick();
              clickHeaderMain(pageLink);
            }}
          >
            {translation?.name}
          </Link>
          <div className="navbar-item-vip-icon" />
        </div>
      )}

      {variant === "highlighted" && (
        <div className="navbar-item-default navbar-item-mobile-wrapper">
          <Link
            className="navbar-item-leaderboard"
            href={pageLink}
            onClick={() => {
              onRouteClick();
              clickHeaderMain(pageLink);
            }}
          >
            {translation?.name}
          </Link>
        </div>
      )}
    </div>
  );
};
